/**
 * Orders Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/orders
 */

const STATUSES = ['paid', 'pending', 'provisioning', 'awaiting_withdrawal_period', 'cancelled', 'failed'];
const PROVIDERS = ['stripe', 'paypal', 'sepa', 'manual'];

function pad(n, w = 5) {
  return String(n).padStart(w, '0');
}

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_ORDERS_DB__) {
    window.__ORBIT_ORDERS_DB__ = { refunded: {} };
  }
  return window.__ORBIT_ORDERS_DB__;
}

export function ordersFixture({ search = '', status = '', provider = '' } = {}) {
  const db = persist();
  const now = Date.now();
  const all = [];
  for (let i = 0; i < 60; i += 1) {
    const id = 88_000 + i;
    const rawStatus = STATUSES[i % STATUSES.length];
    const stat = db?.refunded?.[id] ? 'refunded' : rawStatus;
    const createdAt = new Date(now - i * 3 * 3_600_000).toISOString();
    const paidAt = stat === 'paid' || stat === 'refunded' ? new Date(now - i * 3 * 3_600_000 + 60_000).toISOString() : null;
    all.push({
      id,
      orderNumber: `ORD-2026-${pad(id - 87_000)}`,
      user: {
        id: 4700 + (i % 30),
        email: `customer${4700 + (i % 30)}@example.com`,
        displayName: `Customer #${4700 + (i % 30)}`,
      },
      items: [
        { sku: i % 2 === 0 ? 'pro-monthly' : 'business-yearly', quantity: 1, unitAmount: (i % 2 === 0 ? 1999 : 19900), vatRate: 19 },
        ...(i % 5 === 0 ? [{ sku: 'addon-backup', quantity: 1, unitAmount: 499, vatRate: 19 }] : []),
      ],
      status: stat,
      provider: PROVIDERS[i % PROVIDERS.length],
      total: (i % 2 === 0 ? 1999 : 19900) + (i % 5 === 0 ? 499 : 0),
      currency: 'EUR',
      vatTotal: Math.round(((i % 2 === 0 ? 1999 : 19900) + (i % 5 === 0 ? 499 : 0)) * 0.19 / 1.19),
      acceptanceAgbVersion: '2026-v1',
      acceptancePrivacyVersion: '2026-v1',
      acceptanceWithdrawalVersion: '2026-v1',
      createdAt,
      paidAt,
    });
  }

  const filtered = all.filter((o) => {
    if (search) {
      const q = search.toLowerCase();
      const blob = `${o.orderNumber} ${o.user.email} ${o.items.map((i) => i.sku).join(' ')}`.toLowerCase();
      if (!blob.includes(q)) return false;
    }
    if (status && o.status !== status) return false;
    if (provider && o.provider !== provider) return false;
    return true;
  });

  return { orders: filtered, total: filtered.length };
}

export function orderDetailFixture(id) {
  const { orders } = ordersFixture();
  const o = orders.find((x) => x.id === Number(id));
  if (!o) return null;
  return { order: o };
}

export function refundOrderFixture({ id }) {
  const db = persist();
  if (db) db.refunded[id] = true;
  return {
    creditNoteId: `CN-2026-${pad(id - 87_000)}`,
    refundedAmount: 1999,
    currency: 'EUR',
    method: 'lexware',
  };
}
